/**
 * Normalises an unknown thrown value into an `Error`.
 *
 * The transport throws `ApiError` and `ContractMismatchError`, but a rejected
 * promise can carry anything. A screen must never render `[object Object]`.
 */
export function toError(cause: unknown): Error {
  return cause instanceof Error ? cause : new Error(String(cause));
}
